import { render } from "./orderList.vue?vue&type=template&id=9ebc3276"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
script.render = render

export default script